/** Enum of all available languages */
export enum Language {
  /** English */
  EN = 'EN',

  /** French */
  FR = 'FR',

  /** German */
  DE = 'DE',

  /** Spanish */
  ES = 'ES',

  /** Dutch */
  NL = 'NL',

  /** Italian */
  IT = 'IT',
}

export enum LanguageCode {
  /** German */
  DE = 'de',
  /** English */
  EN = 'en',
  /** Spanish */
  ES = 'es',
  /** French */
  FR = 'fr',
  /** Italian */
  IT = 'it',
  /** Dutch */
  NL = 'nl',
}
